export interface TooltipState {
  visibility: string;
  isFirstActiveTooltip: boolean;
}

export enum Placement {
  Top = `top`,
  Right = `right`,
  Bottom = `bottom`,
  Left = `left`,
}
export enum PositioningStrategy {
  Absolute = `absolute`,
  Fixed = `fixed`,
}

export enum DisplayType {
  Default = `default`,
  Error = `error`,
}

export enum DisplaySize {
  Small = `small`,
  Medium = `medium`,
  Large = `large`,

  Fit = `fit`,
}

export type TooltipAttrs = {
  'always-show'?: boolean;
  'delay-in'?: number;
  'delay-out'?: number;
  'max-width'?: string;
  offset?: number;
  placement?: Placement;
  type?: DisplayType;
  'image-src'?: string;
  size?: DisplaySize;
  text?: string;
  'position-strategy'?: PositioningStrategy;
};

export interface TooltipJsxProps {
  attrs?: TooltipAttrs;
  on?: EmptyObj;
  props?: EmptyObj;
}
